import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RankingIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M4.55768 10.6666H2.33268C1.41602 10.6666 0.666016 11.4166 0.666016 12.3333V16.4999C0.666016 16.9583 1.04102 17.3333 1.49935 17.3333H4.55768C5.01602 17.3333 5.39102 16.9583 5.39102 16.4999V11.4999C5.39102 11.0416 5.01602 10.6666 4.55768 10.6666Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M10.1077 7.33328H7.88268C6.96602 7.33328 6.21602 8.08328 6.21602 8.99994V16.4999C6.21602 16.9583 6.59102 17.3333 7.04935 17.3333H10.941C11.3993 17.3333 11.7743 16.9583 11.7743 16.4999V8.99994C11.7743 8.08328 11.0327 7.33328 10.1077 7.33328Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M15.666 13.1666H13.441C12.9827 13.1666 12.6077 13.5416 12.6077 13.9999V16.4999C12.6077 16.9583 12.9827 17.3333 13.441 17.3333H16.4993C16.9577 17.3333 17.3327 16.9583 17.3327 16.4999V14.8333C17.3327 13.9166 16.5827 13.1666 15.666 13.1666Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M11.5077 3.04161C11.766 2.78328 11.866 2.47494 11.7827 2.20828C11.6993 1.94161 11.441 1.74994 11.0743 1.69161L10.2743 1.55828C10.241 1.55828 10.166 1.49994 10.1493 1.46661L9.70768 0.583276C9.37435 -0.0917236 8.61602 -0.0917236 8.28268 0.583276L7.84102 1.46661C7.83268 1.49994 7.75768 1.55828 7.72435 1.55828L6.92435 1.69161C6.55768 1.74994 6.30768 1.94161 6.21602 2.20828C6.13268 2.47494 6.23268 2.78328 6.49102 3.04161L7.10768 3.66661C7.14102 3.69161 7.16602 3.79161 7.15768 3.82494L6.98268 4.59161C6.84935 5.16661 7.06602 5.42494 7.20768 5.52494C7.34935 5.62494 7.65768 5.75828 8.16602 5.45828L8.91602 5.01661C8.94935 4.99161 9.05768 4.99161 9.09102 5.01661L9.83268 5.45828C10.066 5.59994 10.2577 5.64161 10.4077 5.64161C10.5827 5.64161 10.7077 5.57494 10.7827 5.52494C10.9243 5.42494 11.141 5.16661 11.0077 4.59161L10.8327 3.82494C10.8243 3.78328 10.8493 3.69161 10.8827 3.66661L11.5077 3.04161Z",
      fill: props.color || '#8897A8',
      "fill-opacity": "1"
    }, null, 8, _hoisted_5)
  ]))
}
}

})